import $ from "jquery";
// eslint-disable-next-line no-undef
import "core-js/modules/es.string.starts-with";


// BMI CALCULATE
function calculateBMI(weight, height_ft, height_in) {
  const d = weight / 2.20462;
  const f = height_ft * 0.3048;
  const g = height_in * 0.0254;
  return Number((d / (f + g) ** 2).toFixed(1));
}

$(function() {
  const buttonGoToQuestions = $("#btn-guide");
  const contaonerBMICalculation = $("#bmi-calculated");
  const formBMI = $("#bmi-guide");
  const btnFirst = $("#btnFirst");
  const inputsConditions = $("#bmi-guide input");
  let calculatedBMI;

  inputsConditions.on("change", function() {
    const countActiveConditions = inputsConditions.toArray().filter((a) => a["checked"]).length;
    if (calculatedBMI && ((calculatedBMI >= 27 && calculatedBMI <= 29.9 && countActiveConditions > 0) || calculatedBMI >= 30)) {
      $("#candidate-text").text("Your results show that you may be a candidate for CONTRAVE.");
      $("#candidate-text-secondary").text("Talk to your healthcare provider to see if CONTRAVE is right for you.");
      $("#btn-calculate").removeAttr("disabled");
    } else if (calculatedBMI) {
      $("#candidate-text").text("You do not meet the indicated criteria for using CONTRAVE.");
      $("#candidate-text-secondary").html(`However, it’s always good to talk with your healthcare provider about your health and wellness goals. Even if you aren’t able to receive a prescription for CONTRAVE, there are resources that may be able to help you on your weight-loss journey. <br /> <a href="/resources/" class="text-secondary text-underline">See CONTRAVE resources.</a>`);
      $("#btn-calculate").attr("disabled", true);
    }
  });

  $("button[type='reset']").on("click", () =>
    buttonGoToQuestions.addClass("disabled")
  );

  formBMI.validate({
    errorClass: "error",
    errorElement: "span",
    errorPlacement(error, element) {
      console.log(error, element, element.next("p"));
      error.appendTo(element.next("p"));
    },

    submitHandler(element) {
      const data = new FormData(element);

      const BMICalculation = calculateBMI(
        data.get("weight_lbs_"),
        data.get("height__ft_"),
        data.get("height__in_")
      );
      calculatedBMI = calculateBMI(
        data.get("weight_lbs_"),
        data.get("height__ft_"),
        data.get("height__in_")
      );
      contaonerBMICalculation.text(BMICalculation);

      // console.log({ inputs })
      if (BMICalculation) {
        btnFirst.addClass("d-none");
        $("#bmi-result").addClass("d-block").removeClass("d-none");
        $("#bmi-result-text").text(`[${BMICalculation}]`);
      }
      const countActiveConditions = inputsConditions.toArray().filter((a) => a["checked"]).length;
      if ((BMICalculation >= 27 && BMICalculation <= 29.9 && countActiveConditions > 0) || BMICalculation >= 30) {
        $("#candidate-text").text("Your results show that you may be a candidate for CONTRAVE.");
        $("#candidate-text-secondary").text("Talk to your healthcare provider to see if CONTRAVE is right for you.");
        $("#btn-calculate").removeAttr("disabled");
      } else {
        $("#candidate-text").text("You do not meet the indicated criteria for using CONTRAVE.");
        $("#candidate-text-secondary").html(`However, it’s always good to talk with your healthcare provider about your health and wellness goals. Even if you aren’t able to receive a prescription for CONTRAVE, there are resources that may be able to help you on your weight-loss journey. <br /> <a href="/resources/" class="text-secondary text-underline">See CONTRAVE resources.</a>`);
        $("#btn-calculate").attr("disabled", true);
      }

      // Convert values to HubSpot array
      const fields = [
        { objectTypeId: "0-1", name: "bmi", value: BMICalculation },
      ];
      $("input, select", formBMI).each(function () {
        let value = $(this).val();
        if (
          ($(this).attr("type") === "checkbox" ||
            $(this).attr("type") === "radio") &&
          !$(this).is(":checked")
        ) {
          value = "";
        }
        if (this.name) {
          fields.push({
            objectTypeId: "0-1",
            name: this.name,
            value,
          });
        }
      });
      window.sessionStorage?.setItem("bmi-guide", JSON.stringify(fields));
      // Enable next button
      buttonGoToQuestions.removeClass("disabled");
    },
    invalidHandler() {
      buttonGoToQuestions.addClass("disabled");
    },
    rules: {
      age: { required: true, min: 18, max: 99 },
      height__ft_: { required: true, min: 4, max: 9 },
      height__in_: { required: true, min: 0, max: 11 },
      weight_lbs_: { required: true },
      check_any_related_conditions_you_may_have_: { required: false },
    },
    messages: {
      age: "Age must be between 18 and 99",
      height__ft_: "Height (Feet) must be between 4 and 9",
      height__in_: "Height (Inches) must be between 0 and 11",
      weight_lbs_: "Weight must be between 100 and 999",
    },
  });

  // FORM VALIDATION END

  if (location.pathname.startsWith("/questions")) {
    const prevValues = JSON.parse(
      window.sessionStorage?.getItem("bmi-guide") || "[]"
    );
    if (prevValues.length === 0) {
      window.location.replace("/guide/");
    }
  }

  // Questions

  // Min and Max for inputs
  $(".quest-n-verification").on("input", function() {
    let inputValue = $(this).val();

    // If the input value is an empty string, allow it to be blank
    if (inputValue === "") {
      $(this).val(inputValue); // No se realiza ningún cambio
      return;
    }

    // If it is not an empty string, perform the validations
    inputValue = inputValue.replace(/\D/g, '');
    inputValue = Math.min(Math.max(inputValue, 1), 5);
    $(this).val(inputValue);
  });
  {
    const allOfAbove = $("input#all");
    const checkboxes = $("#activateQuestion input[type=checkbox]")
      .not(allOfAbove)
      .not("#other1");
    allOfAbove.on("change", function () {
      // uncheck all checkboxes if they are checked
      if (this.checked)
        checkboxes.filter(":checked").prop("checked", false).trigger("change");
    });
    checkboxes.on("change", function () {
      // If any checkbox is checked and all is checked, uncheck the all checkbox
      if (this.checked && allOfAbove.is(":checked"))
        allOfAbove.prop("checked", false).trigger("change");
    });
  }

  function setActiveSteps(stepNumber) {
    // Select all elements with class 'step' inside '#bmi-stepper'
    const steps = $('#bmi-stepper .step');
    updateNextButton(stepNumber);
    // Remove 'active' class from all steps
    steps.removeClass('active');

    // Add 'active' class to all steps with data-step less than or equal to stepNumber
    steps.each(function() {
        const step = $(this);
        if (parseInt(step.attr('data-step')) <= stepNumber) {
            step.addClass('active');
        }
    });
}

const footerTexts = {
  '1': 'Sharing your goals with your healthcare provider will help them better understand what motivates you and will allow them to design a plan that works for you to keep you on track.',
  '2': 'It’s important to share a complete history of the experiences you have had while trying to lose weight. For some people, diet and exercise alone isn’t enough. Tell your healthcare provider about what you’ve tried and what your experiences have been like.',
  '3': 'It may be time to try a different approach to get the weight-loss results you desire and reach your health goals.',
  '4': 'Your healthcare provider can prescribe an FDA-approved oral medication that works to reduce hunger and control cravings. When used in addition to a reduced-calorie diet and exercise plan, it can help people lose weight and keep it off.',
  '5': "Some people experience challenges when trying to lose weight. That's why it is important to be specific with your healthcare provider about what you experience and struggle with when it comes to finding a weight-management plan that works for you.",
  '6': "The struggles you're facing are real. Tell your healthcare provider about them so that, together, you and your healthcare provider can decide on a solution that may work for you."
};

const updateFooterText= (num) => {
  $('#bmi-footer-text').text(footerTexts[num]);
};

$('input[type="radio"]').on('click', function() {
  const $radio = $(this);

  // check if the radio was already selected
  if ($radio.data('wasChecked')) {
      $radio.prop('checked', false);
      $radio.data('wasChecked', false);
  } else {
      // mark this radio as checked
      $radio.data('wasChecked', true);
      // uncheck others in the group
      $('input[name="' + $radio.attr('name') + '"]').not($radio).data('wasChecked', false);
  }
});

  $("#bmi-btn-next").on("click", () => {
    const currentStep = $("#bmi-questions").data("current-question");
    const number = currentStep.split('-').at(-1);
    if (number < 6) {
      // Hide current question
      $(`#${currentStep}`).removeClass("show").addClass("d-none");
      // show next question
      const nextNum = Number(number) + 1;
      const nextQuestion = `disabled-quest-${nextNum}`;
      $(`#${nextQuestion}`).addClass("show").removeClass("d-none");
      $("#bmi-questions").data("current-question", nextQuestion);
      setActiveSteps(nextNum);
      $('#bmi-footer-text').text(footerTexts[nextNum]);
      if (nextNum === 6) {
        $('#bmi-text-terms').addClass('d-block').removeClass('d-none');
      }
    }
    if (number == 6) {
      $("#bmi-email").addClass("d-flex").removeClass("d-none");
      $("#bmi-main-assessment").addClass("d-none").removeClass("d-flex");
      $("#bmi-footer").addClass("d-none").removeClass("d-flex");
    }
  });

  $("#bmi-btn-back, #bmi-btn-back-final").on("click", () => {
    const currentStep = $("#bmi-questions").data("current-question");
    const isEmailSectionVisible = $("#bmi-email").is(":visible");

    if (isEmailSectionVisible) {
      // Si estamos en la sección de email, regresar a la última pregunta
      $("#bmi-email").addClass("d-none").removeClass("d-flex");
      $("#bmi-main-assessment").removeClass("d-none").addClass("d-flex");
      $("#bmi-footer").removeClass("d-none").addClass("d-flex");

      const lastQuestionStep = `disabled-quest-6`; // Cambia al último paso de preguntas
      $(`#${lastQuestionStep}`).addClass("show").removeClass("d-none");
      $("#bmi-questions").data("current-question", lastQuestionStep);
      setActiveSteps(6); // Marca el último paso como activo
      $('#bmi-footer-text').text(footerTexts[6]);
      return; // Finaliza aquí para no ejecutar más lógica
    }

    // Lógica normal de retroceso
    const number = currentStep.split('-').at(-1);
    if (Number(number) > 1) {
      const nextNum = Number(number) - 1;
      const nextQuestion = `disabled-quest-${nextNum}`;
      $(`#${currentStep}`).removeClass("show").addClass("d-none");
      $(`#${nextQuestion}`).addClass("show").removeClass("d-none");
      $("#bmi-questions").data("current-question", nextQuestion);
      setActiveSteps(nextNum);
      $('#bmi-footer-text').text(footerTexts[nextNum]);
      $('#bmi-text-terms').addClass('d-none').removeClass('d-block');
    }
  });

  $("#bmi-questions-submit").on("click", () => {
    const inputs = $("#bmi-questions input, #bmi-questions textarea");
    const fields = [];
    const prevValues = JSON.parse(
      window?.sessionStorage.getItem("bmi-guide") || "[]"
    );
    if (Array.isArray(prevValues)) {
      fields.push(...prevValues);
    }
    inputs.each(function () {
      let value = $(this).val();

      // Only include the value if the input is checked (for checkboxes and radios)
      if ($(this).attr("type") === "checkbox" || $(this).attr("type") === "radio") {
        if (!$(this).is(":checked")) {
          value = ""; // If not checked, clear the value
        }
      }

      // Push the field data to the array
      if (value !== "") {
        fields.push({
          objectTypeId: "0-1",
          name: this.name,
          value,
        });
      }
    });
    console.log("VALUES: ", fields);

    const data = {
      submittedAt: Date.now(), // This millisecond timestamp is optional. Update the value from "1517927174000" to avoid an INVALID_TIMESTAMP error.
      fields,
      context: {
        // hutk: ":hutk", // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
        pageUri: "www.contrave.com/",
        pageName: "Contrave",
      },
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text: "I agree to allow Example Company to store and process my personal data.",
          communications: [
            {
              value: true,
              subscriptionTypeId: 999,
              text: "I agree to receive marketing communications from Example Company.",
            },
          ],
        },
      },
    };

    $.ajax({
      type: "POST",
      dataType: "json",
      url: "https://api.hsforms.com/submissions/v3/integration/submit/21790357/6daa8432-1d37-41be-bab0-f6a8b4d48815",
      data: JSON.stringify(data),
      contentType: "application/json; charset=utf-8",
      success(response) {
        console.log("Response: ", response);
        if (window.fbq) {
          console.log('CompleteRegistration')
          window.fbq('track', 'CompleteRegistration');
        }
        window.dataLayer?.push({ 'event':'pwa_form_completed' });
        window.dataLayer?.push({  'event':'wl_assessment', 'page_name':'wl_completion'});
        $("#bmi-email").addClass("d-none").removeClass("d-flex");
        $("#bmi-thank-you").removeClass("d-none").add("d-flex");
      },
      error(error) {
        console.error("error", error?.responseJSON?.errors ?? error);
      },
    });
  });

  $("#bmi-questions").on("submit", (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  $("[data-show-if]").each(function () {
    const ifProp = $(this);
    const dependentElement = ifProp.data("show-if");
    $(dependentElement).on("change", ({ currentTarget }) => {
      const should =
        currentTarget.type === "checkbox" || currentTarget.type === "radio"
          ? currentTarget.checked
          : currentTarget.value;
      if (should) {
        ifProp.show();
        ifProp.removeClass("d-none");
      } else {
        ifProp.hide();
        ifProp.focus();
      }
    });
  });

  createChangeFor(1, "checked");
  createChangeFor(2, "checked");
  createChangeFor(3, "checked");
  createChangeFor(4, "checked");
  createChangeFor(5, "checked");
  createChangeFor(6, "checked");

  function updateNextButton(step) {
    const parent = $(`#disabled-quest-${step}`);
    const inputs = $(`.quest-input-0${step}`, parent);
    const nextButton = $("#bmi-btn-next");
    // Enable next section
    const countActiveInputsCheck = inputs.toArray().filter((a) => a["checked"]).length;
    const countActiveInputsValue = inputs.toArray().filter((a) => a["value"]).length;

    if (countActiveInputsCheck > 0 && countActiveInputsValue > 0) {
      nextButton.removeAttr("disabled");
    } else {
      nextButton.attr("disabled", true);
    }
  }

  function createChangeFor(index, key = "value") {
    const parent = $(`#disabled-quest-${index}`);
    const inputs = $(`.quest-input-0${index}`, parent);
    const nextButton = $("#bmi-btn-next");
    // Enable next section
    inputs.on("change click", function () {
      const countActiveInputs = inputs.toArray().filter((a) => a[key]).length;

      if (countActiveInputs > 0) {
        nextButton.removeAttr("disabled");
      } else {
        nextButton.attr("disabled", true);
      }
    });
  }

});
